import { isBuildCRM } from './EnvironmentUtils';

/**
 * This util function will take string of name of url query and return the value in string format.
 * If given query does not exist, return null
 * @param {string} queryName
 * @returns {string || null}
 */
export const getQueryString = (queryName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(queryName);
};

/**
 * This util function will set url query string with given query name and value.
 * @param {string} queryName name of query
 * @param {string|number} value value of query to be set
 */
export const setQueryString = (queryName, value) => {
  const urlParams = new URLSearchParams(window.location.search);
  const newState = {};
  newState[queryName] = value;
  urlParams.set(queryName, value);

  // Only push the state if not running in CRM mode.
  if (!isBuildCRM()) {
    window.history.pushState(newState, document.title, `?${urlParams.toString()}`);
  }
};
